import { watchEffect } from 'vue'
import {
  locales as localesDeepUiKit,
  setI18nLocale as setI18nLocaleDeepUiKit,
} from '@deepcloud/deep-ui-kit'
import {
  locales as localesDeepUiLib,
  setI18nLocale as setI18nLocaleDeepUiLib,
} from '@deepcloud/deep-ui-lib'
import { i18n } from '@/plugins/i18n'

// Add DeepUiLib locales to app vue-i18n instance
i18n.global.mergeLocaleMessage('de', localesDeepUiKit.de)
i18n.global.mergeLocaleMessage('fr', localesDeepUiKit.fr)
i18n.global.mergeLocaleMessage('it', localesDeepUiKit.it)
i18n.global.mergeLocaleMessage('en', localesDeepUiKit.en)

// Add DeepUiLib locales to app vue-i18n instance
i18n.global.mergeLocaleMessage('de', localesDeepUiLib.de)
i18n.global.mergeLocaleMessage('fr', localesDeepUiLib.fr)
i18n.global.mergeLocaleMessage('it', localesDeepUiLib.it)
i18n.global.mergeLocaleMessage('en', localesDeepUiLib.en)

// update plugins i18n locale
watchEffect(() => {
  setI18nLocaleDeepUiKit(i18n.global.locale.value)
  setI18nLocaleDeepUiLib(i18n.global.locale.value)
})
